// extracted by mini-css-extract-plugin
export default {"label":"SelectControl_label__YZ-t5"};